/* eslint-disable consistent-return */
import { Button, Grid, MenuItem } from '@material-ui/core';
import {
  getBusinesses,
  getBusinessesSectors,
  getContractTypes,
  getDegreeLevels,
  postSubscribeBusiness,
} from '@webapps/business';
import {
  FormikAutocompletePx,
  FormikTextField,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Row from 'components/Form/Row';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const subscribeBusinessSchema = yup.object().shape({
  label: yup.string().required('Requis'),
  city: yup.string().required('Requis'),
  businesses: yup.array().of(
    yup.object({
      id: yup.string(),
    })
  ),
  sectors: yup
    .array()
    .of(
      yup.object({
        id: yup.string(),
      })
    )
    .min(1, 'Requis'),
  contractTypes: yup.array().of(
    yup.object({
      id: yup.string(),
    })
  ),
  levels: yup
    .array()
    .of(
      yup.object({
        id: yup.string(),
      })
    )
    .min(1, 'Requis'),
});

const AddBusinessSubscribe = ({ close, refetch }) => {
  const { css } = useStyles();

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateSubscribeBusiness,
  } = useMutation(postSubscribeBusiness);

  const { addToast } = useToast();

  const {
    data: { content: businesses = [] } = {},
    isLoading: businessLoading,
  } = useQuery(getBusinesses, {
    key: 'allBusinessForSubscribe',
  });

  const { data: jobsSectors = [], isLoading: sectorsLoading } = useQuery(
    getBusinessesSectors,
    {
      key: 'allSectorsJobsForSubscribe',
    }
  );

  const { data: contractTypes = [], isLoading: contractTypesLoading } =
    useQuery(getContractTypes, {
      key: 'contractTypesForSubscribe',
    });

  const { data: levels = [], isLoading: levelsLoading } = useQuery(
    getDegreeLevels,
    {
      key: 'degreeLevelsForSubscribe',
    }
  );

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      close();
    }
  }, [isSuccess]);

  const formik = useFormik({
    initialValues: {
      label: '',
      alertFrequency: 'weekly',
      city: '',
      businesses: [],
      sectors: [],
      contractTypes: [],
      levels: [],
    },
    validationSchema: subscribeBusinessSchema,
    onSubmit: async (values) => {
      await mutateSubscribeBusiness({
        data: values,
        id: idUser,
      });
    },
  });

  return (
    <div>
      <Row>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label={<FormattedMessage id="subscribe.label" />}
              name="label"
              borderRadius={6}
            />
          </Grid>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label={<FormattedMessage id="subscribe.city" />}
              name="city"
              borderRadius={6}
            />
          </Grid>
          <Grid item xs={12}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              label="Domaines d'études"
              multiple
              name="sectors"
              options={jobsSectors}
              value={formik.values.sectors}
              borderRadius={6}
            />
          </Grid>
          <Grid item xs={12}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              label={<FormattedMessage id="subscribe.contractTypes" />}
              loading={contractTypesLoading}
              borderRadius={6}
              loadingText={
                <>
                  <FormattedMessage id="loading" />
                  ...
                </>
              }
              multiple
              name="contractTypes"
              options={contractTypes}
              value={formik.values.contractTypes}
            />
          </Grid>
          <Grid item xs={12}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              borderRadius={6}
              getOptionLabel={(option) => option.label || ''}
              label={<FormattedMessage id="subscribe.levels" />}
              loading={levelsLoading}
              loadingText={
                <>
                  <FormattedMessage id="loading" />
                  ...
                </>
              }
              multiple
              name="levels"
              options={levels}
              value={formik.values.levels}
            />
          </Grid>
        </Grid>
      </Row>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            <Button
              className={css({ borderRadius: '400px' })}
              color="primary"
              disabled={isLoading}
              onClick={formik.handleSubmit}
              variant="contained"
            >
              <FormattedMessage id="vitrine.btnCreate" />
            </Button>
          </Grid>
        </Grid>
      </Row>
    </div>
  );
};

AddBusinessSubscribe.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
};

export default AddBusinessSubscribe;
